var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 13.833C10.2758 13.833 10.4997 13.6091 10.4997 13.333V9.33301C10.4997 9.05687 10.2758 8.83301 9.99967 8.83301C9.72353 8.83301 9.49967 9.05687 9.49967 9.33301V13.333C9.49967 13.6091 9.72353 13.833 9.99967 13.833Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 6.66634C10.3679 6.66634 10.6663 6.96482 10.6663 7.33301C10.6663 7.7012 10.3679 7.99967 9.99967 7.99967C9.63148 7.99967 9.33301 7.7012 9.33301 7.33301C9.33301 6.96482 9.63148 6.66634 9.99967 6.66634Z",
    fill: "#1C274C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.83301 9.99967C2.83301 6.04163 6.04163 2.83301 9.99967 2.83301C13.9577 2.83301 17.1663 6.04163 17.1663 9.99967C17.1663 13.9577 13.9577 17.1663 9.99967 17.1663C6.04163 17.1663 2.83301 13.9577 2.83301 9.99967ZM9.99967 3.83301C6.59392 3.83301 3.83301 6.59392 3.83301 9.99967C3.83301 13.4054 6.59392 16.1663 9.99967 16.1663C13.4054 16.1663 16.1663 13.4054 16.1663 9.99967C16.1663 6.59392 13.4054 3.83301 9.99967 3.83301Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/info_circle.99efc5bac3365f21e14d65f95ccd99a6.svg";
export { ForwardRef as ReactComponent };